var _path;
import * as React from "react";
function SvgArrowCircleDown(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 20c0 8.839-7.161 16-16 16S4 28.839 4 20 11.161 4 20 4s16 7.161 16 16zm-9.265-1.864l-4.67 4.87v-11.78c0-.858-.69-1.549-1.549-1.549h-1.032c-.858 0-1.549.69-1.549 1.549v11.78l-4.67-4.87a1.55 1.55 0 00-2.213-.026l-.704.71a1.542 1.542 0 000 2.186l8.555 8.562a1.542 1.542 0 002.187 0l8.568-8.562a1.542 1.542 0 000-2.187l-.703-.71a1.56 1.56 0 00-2.22.026z"
  })));
}
export default SvgArrowCircleDown;